export default __webpack_public_path__ + "static/media/curriculum.bea6ab52.pdf";